import Featured from "./sub-sections/Featured";
import Sellers from "./sub-sections/Sellers";
import Stats from "./sub-sections/Stats";
import SuperHero from "./sub-sections/superHero";

export default function Home(){
  return (
    <>
    <SuperHero/>
     <Stats/>
    <Featured/>
    <Sellers/>
   
    </>
  )
}